import { render } from "./CustomerLoadWait.vue?vue&type=template&id=cb7b77ba&scoped=true"
import script from "./CustomerLoadWait.vue?vue&type=script&lang=js"
export * from "./CustomerLoadWait.vue?vue&type=script&lang=js"

import "./CustomerLoadWait.vue?vue&type=style&index=0&id=cb7b77ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7b77ba"]])

export default __exports__